import { hrcConstants } from '../../constants'

export function hrc(state={}, action) {
  const {
    guidance,
  } = state
  switch (action.type) {
    case hrcConstants.LIST_HRC_GUIDANCE_REQUEST:
      return { isListingGuidance: true }
    case hrcConstants.LIST_HRC_GUIDANCE_SUCCESS:
      return { guidance: action.payload.data }
    case hrcConstants.LIST_HRC_GUIDANCE_FAILURE:
      return {}
    case hrcConstants.UPDATE_HRC_GUIDANCE_REQUEST:
      return { isUpdatingGuidance: true }
    case hrcConstants.UPDATE_HRC_GUIDANCE_SUCCESS:
      return { guidance: action.payload.data }
    case hrcConstants.UPDATE_HRC_GUIDANCE_FAILURE:
      return { guidance }
    default:
      return state
  }
}
